/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompleteActionPlanInterventionResponse,
  DtoEnvelopeActionPlanIntervention,
  GetActionPlanInterventionsV1ActionPlanInterventionsGetParams,
  HTTPValidationError
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get action plan interventions for the authenticated user.

Query Parameters:
- status: Optional list of statuses to filter by (IN_PROGRESS, COMPLETED, AVAILABLE)
          Can pass multiple values like ?status=IN_PROGRESS&status=COMPLETED
          If not provided, returns all interventions from current action plan

Returns:
    ActionPlanInterventionListResponse with filtered interventions
 * @summary Get Action Plan Interventions
 */
export const getActionPlanInterventionsV1ActionPlanInterventionsGet = (
    params?: GetActionPlanInterventionsV1ActionPlanInterventionsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<DtoEnvelopeActionPlanIntervention>(
      {url: `/v1/action-plan-interventions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetActionPlanInterventionsV1ActionPlanInterventionsGetQueryKey = (params?: GetActionPlanInterventionsV1ActionPlanInterventionsGetParams,) => {
    return [
    `/v1/action-plan-interventions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetActionPlanInterventionsV1ActionPlanInterventionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError = HTTPValidationError>(params?: GetActionPlanInterventionsV1ActionPlanInterventionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActionPlanInterventionsV1ActionPlanInterventionsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>> = ({ signal }) => getActionPlanInterventionsV1ActionPlanInterventionsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActionPlanInterventionsV1ActionPlanInterventionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>>
export type GetActionPlanInterventionsV1ActionPlanInterventionsGetQueryError = HTTPValidationError


export function useGetActionPlanInterventionsV1ActionPlanInterventionsGet<TData = Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetActionPlanInterventionsV1ActionPlanInterventionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>,
          TError,
          Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionPlanInterventionsV1ActionPlanInterventionsGet<TData = Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError = HTTPValidationError>(
 params?: GetActionPlanInterventionsV1ActionPlanInterventionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>,
          TError,
          Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActionPlanInterventionsV1ActionPlanInterventionsGet<TData = Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError = HTTPValidationError>(
 params?: GetActionPlanInterventionsV1ActionPlanInterventionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Action Plan Interventions
 */

export function useGetActionPlanInterventionsV1ActionPlanInterventionsGet<TData = Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError = HTTPValidationError>(
 params?: GetActionPlanInterventionsV1ActionPlanInterventionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActionPlanInterventionsV1ActionPlanInterventionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActionPlanInterventionsV1ActionPlanInterventionsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Complete Action Plan Intervention
 */
export const completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost = (
    actionPlanInterventionId: string,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<CompleteActionPlanInterventionResponse>(
      {url: `/v1/action-plan-interventions/${actionPlanInterventionId}`, method: 'POST', signal
    },
      );
    }
  


export const getCompleteActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost>>, TError,{actionPlanInterventionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost>>, TError,{actionPlanInterventionId: string}, TContext> => {

const mutationKey = ['completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost>>, {actionPlanInterventionId: string}> = (props) => {
          const {actionPlanInterventionId} = props ?? {};

          return  completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost(actionPlanInterventionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPostMutationResult = NonNullable<Awaited<ReturnType<typeof completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost>>>
    
    export type CompleteActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPostMutationError = HTTPValidationError

    /**
 * @summary Complete Action Plan Intervention
 */
export const useCompleteActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost>>, TError,{actionPlanInterventionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost>>,
        TError,
        {actionPlanInterventionId: string},
        TContext
      > => {

      const mutationOptions = getCompleteActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    